/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Add_Gateway_RequiredInputs */



/**
* | output |
* | --- |
* | "A gateway is required" |
*
* @param {Valve_Add_Gateway_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_add_gateway_required = /** @type {((inputs?: Valve_Add_Gateway_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Add_Gateway_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("A gateway is required")
	return /** @type {LocalizedString} */ ("Une passerelle est requise")
});